export function $<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} bulunamadı`);
  return el as T;
}

export function toast(msg: string, isErr = false) {
  let el = document.querySelector<HTMLDivElement>('.toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.toggle('err', isErr);
  el.classList.add('show');
  clearTimeout(Number(el.dataset.t));
  el.dataset.t = String(setTimeout(() => el!.classList.remove('show'), isErr ? 4500 : 2200));
}

export const errMsg = (e: unknown) => (e instanceof Error ? e.message : String(e));

export function clock(el: HTMLElement) {
  const tick = () => {
    el.textContent = new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };
  tick();
  setInterval(tick, 10000);
}

/** Tıklanan öğeden yukarı doğru, verilen seçiciye uyan ilk öğeyi bulur. */
export const closest = <T extends HTMLElement = HTMLElement>(e: Event, sel: string) =>
  (e.target as HTMLElement | null)?.closest<T>(sel) ?? null;
